export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-exchange/kucoin-5c299f026925dc785e955aab2326d463.png";